import {
  Component,
  ViewEncapsulation,
  OnInit, Inject, OnDestroy, ViewChild, AfterViewInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult,
  RowArgs, SelectionEvent
} from '@progress/kendo-angular-grid';

import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../../../../services/user-context/user-context';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../../../../services/api/api.service';
import {DOCUMENT} from '@angular/common';
import {GoogleMapsAPIWrapper, AgmMap, LatLngBounds, LatLngBoundsLiteral} from '@agm/core';
import {LocationDialogComponent} from './location-dialog.component';
import {Observable, Subscription} from "rxjs";
import {LocationsService} from "./locations.service";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {FormControl} from "@angular/forms";
import {HttpParams} from "@angular/common/http";
import {LocationSummaryService} from '../../../../services/location-summary-service';
import {SearchContext} from '../../../../services/search/search-context';


declare var google: any;

@Component({
  selector: 'app-locations',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'locations.template.html'
})
export class LocationsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(AgmMap, {static: false})
  public agmMap: AgmMap;

  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };
  private searchTerm: string;
  public searchText = new FormControl();
  private selectedLocation: RowArgs;
  lat = 35.268107;
  lng = -90.744821;
  zoom = 4;
  private map: any;
  public search: Subscription;

  loading = false;
  public crumbs: any[] = [
    {label: 'Accounts', link: '/accounts'}
  ];
  public markers: any[] = [];
  public mapStyles = [
    {elementType: 'geometry', stylers: [{color: '#aec3cb'}]},
    {elementType: 'labels.text.stroke', stylers: [{'visibility': 'off'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#888888'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#555555'}]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{'visibility': 'off'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#bbdefb'}]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#81d4fa'}]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#e3e8ee'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: 'transparent'}]
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private locationsService: LocationsService,
    private api: ApiService,
    private searchContext: SearchContext,
    private snackBar: MatSnackBar,
    private userContext: UserContext,
    private locationSummaryService: LocationSummaryService,
    @Inject(DOCUMENT) private document: Document) {

    this.view = locationsService;
  }

  public ngOnInit(): void {

  }

  public ngAfterViewInit(): void {


    this.agmMap.mapReady.subscribe(map => {
      this.map = map;
      this.search = this.searchContext.searchObserver.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
        if ((term || "").length >= 3 || (term || "").length === 0) {
          this.state.skip = 0;
          this.view.subscribe((locations) => {
            const markerArray: any[] = [];
            locations.data.map( (marker) => {
              if ( marker.latlng ) {
                markerArray.push({latitude: marker.latlng[0], longitude: marker.latlng[1]});
              }
            });
            this.markers = markerArray;
            this.centerMap();
          });

          this.getLocations(term);
        }
      });
    });
  }

  public ngOnDestroy(): void {
    this.document.body.style.backgroundColor = '#ffffff';
    const mainLayout = this.document.getElementsByTagName('app-main-layout');
    mainLayout[0].classList.remove('white-header');
  }

  public dataLocationStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getLocations(this.searchTerm || '');
  }

  public getLocations(search: string) {
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.locationsService.getLocations(page, limit, () => {
      this.loading = false;
    }, this.userContext.account.id || this.route.snapshot.paramMap.get('id'), search);
  }


  public centerMap(): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const mm of this.markers) {
      bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
    }
    this.map.fitBounds(bounds);
    if ( this.map.getZoom() > 7 ) {
      this.map.setZoom(7);
    }
  }

  public onMapReady($event) {
    this.agmMap.triggerResize(true);
  }

  public onLocationSelection(event: SelectionEvent) {
    this.selectedLocation = event.selectedRows[0];
  }

  public addLocation(): void {
    const dialogRef = this.dialog.open(LocationDialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(location => {

      if ( location ) {
        this.api.post<any>(`/account/${this.userContext.account.id}/location`, location ).subscribe( result => {
          this.snackBar.open('Location added.', null, {
            duration: 2000
          });
          this.getLocations(this.searchTerm || '');
          this.locationSummaryService.locationObserver.next(true);
        }, (error) => {
          this.snackBar.open(`Error adding location: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

  public editLocation(): void {
    const dialogRef = this.dialog.open(LocationDialogComponent, {
      width: '600px',
      data: this.selectedLocation.dataItem
    });

    dialogRef.afterClosed().subscribe(location => {

      if ( location ) {
        this.api.patch<any>(`/location/${location.id}`, location).subscribe( result => {
          this.snackBar.open('Location updated.', null, {
            duration: 2000
          });
          this.getLocations(this.searchTerm || '');
          this.locationSummaryService.locationObserver.next(true);
        }, (error) => {
          this.snackBar.open(`Error updating location: ${error}`, null, {
            duration: 2000
          });
        });
      }

      this.selectedLocation = null;
    });
  }

  public removeLocation(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      data: { message: 'Remove this location?', action: 'Remove'}
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if ( confirmed ) {
        this.api.del<any>(`/location/${this.selectedLocation.dataItem._id}` ).subscribe( result => {
          this.snackBar.open('Location removed.', null, {
            duration: 2000
          });
          this.getLocations(this.searchTerm || '');
          this.locationSummaryService.locationObserver.next(true);
        }, (error) => {
          this.snackBar.open(`Error removing location: ${error}`, null, {
            duration: 2000
          });
        });
      }
      this.selectedLocation = null;
    });
  }

}
